mutation ConnectToEmpro($input: EmproAuthCodeInput!) {
  connectToEmpro(input: $input) {
    idToken
    accessToken
    refreshToken
  }
}
